import {GraphQLResolveInfo} from "graphql";
import {visitArguments} from "../../utils/resolve";
import {omit} from "lodash/object";
import util from "util";
import fs from "fs";

export default async (resolve, parent, args, context, info: GraphQLResolveInfo) => {
    return await resolve(parent, await visitArguments(args, info, context, {
        async enter(argType, argValue, argName, path, context) {
            if (argValue.upload) {
                const { filename, mimetype, createReadStream } = await argValue.upload;
                const tmpPath = 'tmp/' + filename;
                await context.storage.put(tmpPath, createReadStream())
                return omit({
                    ...argValue,
                    path: tmpPath,
                    filename,
                    mimetype,
                    encoding: 'binary', // TODO
                    size: (await util.promisify(fs.stat)(tmpPath)).size
                }, ['upload'])
            }
        }
    }), context, info);
}
